import { Colors } from './colors';
export const InputFrame = {
  // The styles all Cards have in common
  baseStyle: {
    background: 'white',
    alignItems: 'center',
    gap: 6,
  },
  // Two variants: rounded and smooth
  variants: {
    picker: {
      background: '#FFFFFF',
      border: '0.1rem solid' + Colors.borderMain,
      borderRadius: 'base',
      padding: '0px',
      paddingLeft: '8px',
      display: 'flex',
    },
    withoutSpacing: {
      background: '#FFFFFF',
      border: '0.1rem solid' + Colors.borderMain,
      borderRadius: 'base',
      paddingLeft: 0,
      display: 'flex',
    },
  },
  // The default variant value
  defaultProps: {
    variant: 'picker',
  },
};
